var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meter"},[_c('span',{style:('width:'+this.value+'%')})])
}
var staticRenderFns = []

export { render, staticRenderFns }